import { render, staticRenderFns } from "./InstitutionPanel.vue?vue&type=template&id=a656eb66&scoped=true&"
import script from "./InstitutionPanel.vue?vue&type=script&lang=js&"
export * from "./InstitutionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a656eb66",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/party/InstitutionPanel.vue
// module id = 1475
// module chunks = 0